import { useOptionalPrivanaI18n } from '@/i18n/PrivanaI18nProvider'
import React from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { CheckCircle } from 'lucide-react'

export default function MemberReciprocalGuestPassRequestSuccessPage({ clubCode }) {
  const { t: memberText } = useOptionalPrivanaI18n()

  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const requestId = searchParams.get('request_id')

  const handleBack = () => {
    if (clubCode) {
      navigate(`/${clubCode}/reciprocal-clubs`)
    } else {
      navigate('/reciprocal-clubs')
    }
  }

  return (
    <div className="mp-page mp-page--center">
      <div className="mp-card mp-card--center mp-booking-success">
        <CheckCircle size={48} className="mp-success-icon" />
        <h2>{memberText("portalPresentation.member_request_sent")}</h2>
        <p className="mp-text-muted"> {memberText("portalPresentation.member_your_guest_pass_request_has_been_submitted_we_ll_notify_you_once_it_s_approved")} </p>
        {requestId ? <p className="mp-label">{memberText("portalPresentation.member_request_reference")} {requestId}</p> : null}
        <button type="button" className="mp-btn mp-btn--primary" onClick={handleBack}> {memberText("portalPresentation.member_back_to_reciprocal_clubs")} </button>
      </div>
    </div>
  )
}
